<template>
    <a-affix @change="changeAffix" :offset-top="70" class="affix">
        <div class="top">
            <div class="btns">
                <slot></slot>
            </div>
            <a-textarea v-model="message" style="margin-top:12px" placeholder="请输入意见" :rows="rows" />
            <a-upload v-if="showFileList" name="file" :accept="accept" :default-file-list="fileList" :headers="headers"
                :action="actionPath" :before-upload="beforeUpload" @change="handleChangeUpload">
                <div class="upload-btn pointer">
                    <a-icon type="upload" />&nbsp;上传附件
                </div>
            </a-upload>
            <div>
                <slot name="more"></slot>
            </div>

        </div>
    </a-affix>
</template>

<script>
import { _ctxPath, _accept } from '@/api/http'
import { stagingEcho } from '@/api/double-hundred/common'
export default {
    name: 'XiamenTalentUi1Index',
    props: {
        showFileList: {
            type: Boolean
        },
        path: {
            type: String,
            default: ''
        },

    },
    data() {
        return {
            id: this.$route.query.id,
            rows: 2,
            message: "",
            fileList: [],
            attachment: []
        };
    },
    created() {
        if (this.path) {
            // this.message =this.id
            let id = this.$route.query.id
            stagingEcho({ id }).then(res => {
                console.log('id', res);
                if (res.code == 0) {
                    this.message = res.data.opinionContent
                    res.data.attachment.forEach((element, index) => {
                        this.fileList.push({
                            uid: index,
                            name: element.fileName,
                            status: 'done',
                            url: element.url,
                            storageKey: element.storageKey
                        })
                        this.attachment.push(element.storageKey)
                    });
                }
            })
        }
    },
    computed: {
        accept() {
            return _accept
        },
        actionPath() {
            return _ctxPath + '/xmt/file/upload'
        },
        headers() {
            return {
                Authorization: 'Bearer ' + this.$store.getters.token
            }
        }
    },
    methods: {
        changeAffix(affixed) {
            if (affixed) {
                this.showSmallRow = true;
                this.rows = 1

            } else {
                this.showSmallRow = false;
                this.rows = 2
            }
        },
        handleChangeUpload(file) {
            const { fileList } = file
            this.attachment = []
            let spliceIndex = -1
            fileList.forEach((item, index) => {
                const res = item.response
                if (res?.code === 200) {
                    this.attachment.push(res.data[0].storageKey)
                } else if (res?.code === 500) {
                    this.$message.error(res.msg)
                    spliceIndex = index
                } else if (item.storageKey) {
                    this.attachment.push(item.storageKey)
                }
            })
            if (spliceIndex > -1) {
                fileList.splice(spliceIndex, 1)
            }
            this.fileList = fileList;
            console.log("this.fileList", this.fileList);
        },
        beforeUpload(file) {
            const isLt50M = file.size / 1024 / 1024 < 50;
            if (!isLt50M) {
                this.$message.error('请上传小于50MB的文件!');
            }
            return isLt50M;
        },
    },
};
</script>

<style lang="less" scoped>
.top {
    margin-top: 0px;
    box-shadow: 0 6px 30px 5px #0000000d, 0 16px 24px 2px #0000000a, 0 8px 10px -5px #00000014;
    padding: 12px 16px;
    background-color: #fff;
}

.btns {
    width: 100%;
    // height: 28px !important;
    display: flex;
    flex-wrap: wrap;
}

.upload-btn {
    margin-top: 10px;
}

.affix {
    margin-bottom: 0 !important;
}

::v-deep {
    textarea.ant-input {
        border: 4px solid #f0f8ff;
        background: #f9fafb;
        // resize: none;
    }
}
</style>